/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '@babel/polyfill';

require('./bootstrap');
require('bootstrap-select/js/bootstrap-select');
require('flip/dist/jquery.flip');

import bsCustomFileInput from 'bs-custom-file-input'

window.Vue = require('vue').default;
import VueRouter from 'vue-router';

import { routes } from './routers';

import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);
Vue.use(VueRouter);
Vue.component('home-component', require('./components/Home.vue').default);
Vue.component('navbar-component', require('./components/Navbar.vue').default);

Vue.component('admin-component', require('./components/admin/Admin.vue').default);
Vue.component('vue-dropzone', vueDropzone);

if(process.env.MIX_ENV_MODE === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes,

    scrollBehavior: function (to) {

        if (to.hash)
        {
          return {
            selector: to.hash,
            behavior: 'smooth',
          }
        }
    },
})

const app = new Vue({
    el: '#app',
    comments: false,
    data(){
        return{
            isCardDesc: false,
            showDescrpition: false,
        }
    },
    router
});

$(function()
{
    bsCustomFileInput.init()

    $('.modal')
    .on('show.bs.modal', function() {
        $('html').css('overflow', 'hidden');
    })
    .on('hidden.bs.modal', function (event) {
        $('html').css('overflow', '')
    })

    // Animation background

    // set up the canvas and context
    if($('.bg-fixed').length > 0)
    {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = window.innerHeight;
        canvas.width = window.innerWidth;
        canvas.classList.add('bg-fixed');
        document.body.appendChild(canvas);

        var requestAnimationFrame = window.requestAnimationFrame ||
                                    window.mozRequestAnimationFrame ||
                                    window.webkitRequestAnimationFrame ||
                                    window.msRequestAnimationFrame;

        let image = new Array();

        image[0] = '/img/background/el.png';
        image[1] = '/img/background/el1.png';
        image[2] = '/img/background/el2.png';
        image[3] = '/img/background/el3.png';
        image[4] = '/img/background/el4.png';
        image[5] = '/img/background/el5.png';
        image[6] = '/img/background/el6.png';
        image[7] = '/img/background/el7.png';
        image[8] = '/img/background/el8.png';
        image[9] = '/img/background/el9.png';
        image[10] = '/img/background/el10.png';

        let rand = 0,
            x = 0,
            y = 0,
            up = true,
            width,
            height;

        // let img = new Image();
        // img.src = '/img/background/el4.png';

        // img.onload = (function(img) {

        //     return function(){
        //         ctx.drawImage(img, 80, 200);
        //         drawImage();
        //     };
        // })(img);

        function drawImage() {
            width = img.width + x;
            height = img.height + y;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 80 - width/2, 200 - height/2, width, height);

            if(x == 10)
            {
                up = false;
            }
            else if(x == 0) up = true;

            if(up === true)
            {
                x++;
                y++;
            }
            else if(up === false)
            {
                x--;
                y--;
            }

            requestAnimationFrame(drawImage);
        }
    }

});

